<template>
  <div class="grid-x grid-padding-x upload-wrapper">
    <div class="cell small-12">
      <file-upload
        ref="upload" 
        v-bind:name="'file_upload'" 
        v-model="files"
        v-bind:post-action="endpoint" 
        @input="uploadFile" 
        @input-file="inputFile"
        @input-filter="inputFilter" 
        :multiple="options.allow_multiple" 
        :drop="true" 
        :extensions="options.allowed_filetypes" 
        :maximum="options.max_files"  
        :data="{field_id: options.id}">
        <span v-html="getUploadLabel"></span>
      </file-upload>
      <template v-if="files.length">
        <table class="">
          <thead>
            <tr>
              <th style="width: 50%">File</th>
              <th style="width: 20%">Size</th>
              <th style="width: 15%">Status</th>
              <th style="width: 15%">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in files" v-bind:key="index">
              <td>{{file.name}}</td>
              <td>{{formatBytes(file.size)}}</td>
              <td v-html="getProgress(file.progress)"></td>
              <td><a href="#" @click.prevent="removeFile(file)">Remove</a></td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import FileUpload from 'vue-upload-component'

export default { 
  name: 'FileUploadField',
  components: {
    FileUpload
  },
  data () {
    return {
      files: []
    }
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    inputFile (new_file, old_file) {
      if (new_file && old_file && !new_file.active && old_file.active) {
        this.handleUploadedFile(new_file)
      }
    },
    inputFilter (new_file, old_file, prevent) {

      if (new_file && !old_file) {

        let vm = this
        let ext = new_file.name.split('.').pop()
        let allowed = false

        // Check allowed file types
        if (vm.options.allowed_filetypes) {
          _.find(vm.options.allowed_filetypes, function(filetype) { 

            if (ext.toLowerCase() == filetype.toLowerCase()) {
              allowed = true;
            }
          })
        }

        if (this.options.max_files > 0 && this.files.length >= this.options.max_files) {
          alert('Sorry, maximum allowed files has been reached.')
          return prevent();
        }

        // Filter non-image file
        if (allowed == false) {
          alert('Sorry, ' + ext + ' is not an accepted file type.')
          return prevent()
        }
      }

      // Create a blob field
      /*new_file.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        new_file.blob = URL.createObjectURL(new_file.file)
      }*/
    },
    handleUploadedFile (upload) {
      if (upload.xhr.status == '200') {
        if (upload.response.success) {
          this.$commit.addUploadedFile({
            key: 'field-' + this.options.id, 
            value: upload.response.data
          })
        } else {
          alert('file upload failed')
        }
      } else {
        alert('bad response')
      }
    },
    formatBytes (bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    getProgress (progress) {
      let width = parseInt(progress);
      if (width == 100) {
        return this.$icons.get('check', 'medium primary')
      } else {
        return '<div style="width: ' + width + 'px; height: 10px; background-color: blue"></div>'
      }
    },
    uploadFile () {
      this.$refs.upload.active = true
    },
    removeFile (file) {
      // Remove from component
      this.$refs.upload.remove(file)
      // Remove from data store
      this.$commit.removeUploadedFile({
        key: 'field-' + this.options.id,
        value: file.response.data.id
      });
    },
    validate () {
      return true // for now
    }
  },
  computed: {
    fieldValue: {
      get () {
        return this.$store.formData['field-' + this.options.id]
      },
      set (val) {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val
        })
      }
    },
    endpoint () {
      return this.$store.config.url + '/upload'
    },
    showUploadButton () {
      if ((!this.$refs.upload || !this.$refs.upload.active) && this.files.length) {
        return true
      } else {
        return false
      }
    },
    getUploadLabel () {
      if (this.options.allow_multiple == true) {
        return '<strong>Click</strong> or drop your file(s) here'
      } else {
        return '<strong>Click</strong> or drop your file here'
      }
    }
  }
}
  
</script>
